import { Action, createReducer, on } from '@ngrx/store';
import { IClientActivitiesState } from './client-activities';
import { IParcelData } from '../../interfaces/response-verify-delivery';
import { ResponseAccettazioneDatamatrix, ResponseConfirmClientAcceptance, ResponseConfirmCodiceBusta, ResponseEtichettaLottomatica, ResponseEtichettaWebApp } from '../../interfaces/response-confirm-client-acceptance';
import { RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE_DATAMATRIX_SUCCESS, RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE_SUCCESS, RETRIEVE_CONFIRM_CODICE_BUSTA_SUCCESS, RETRIEVE_CONSEGNA_PACCO_SUCCESS, RETRIEVE_ETICHETTE_LOTTOMATICA_SUCCESS, RETRIEVE_ETICHETTE_WEBAPP_SUCCESS, RETRIEVE_PACCO_SMARRITO_SUCCESS, RETRIEVE_PARCEL_SALE_SUCCESS, RETRIEVE_RIFIUTA_PACCO_SUCCESS, RETRIEVE_VERIFY_DELIVERY_NO_PIN_SUCCESS, RETRIEVE_VERIFY_DELIVERY_SUCCESS, RETRIEVE_VERIFY_SALE_SUCCESS } from './client-activities.actions';
import { IResponseRifiutaPacco } from '../../interfaces/rifiuta-pacco';
import { ISaleData } from '../../interfaces/response-verify-sale';
import { IResponsePaccoSmarrito } from '../../interfaces/pacco-smarrito';
import { IParcelSale } from '../../interfaces/response-parcel-sale';

/* INITIAL STATE */
const initialState: IClientActivitiesState = {
  responseVerifyDelivery: null,
  responseVerifyDeliveryNoPin: null,
  responseRifiutaPacco: null,
  responseConsegnaPacco: null,
  responseConfirmClientAcceptance: null,
  responseConfirmClientAcceptanceDatamatrix: null,
  responsePaccoSmarrito: null,
  responseEtichettaWebApp: null,
  responseEtichettaLottomatica: null,
  responseConfirmCodiceBusta: null,
  responseVerifySale: null,
  responseParcelSale:null,
  responseVerificaAccettazioneStampaPaperless:null,

};

const handleSetVerifyDelivery = (
  state: IClientActivitiesState,
  { responseVerifyDelivery }: { responseVerifyDelivery: IParcelData | null }
): IClientActivitiesState => {
  return {
    ...state,
    responseVerifyDelivery,
  };
};

const handleSetVerifyDeliveryNoPin = (
  state: IClientActivitiesState,
  { responseVerifyDeliveryNoPin }: { responseVerifyDeliveryNoPin: IParcelData | null }
): IClientActivitiesState => {
  return {
    ...state,
    responseVerifyDeliveryNoPin,
  };
};

const handleSetRifiutaPacco = (
  state: IClientActivitiesState,
  { responseRifiutaPacco }: { responseRifiutaPacco: IResponseRifiutaPacco | null }
): IClientActivitiesState => {
  return {
    ...state,
    responseRifiutaPacco,
  };
};

const handleSetConsegnaPacco = (
  state: IClientActivitiesState,
  { responseConsegnaPacco }: { responseConsegnaPacco: IResponseRifiutaPacco | null }
): IClientActivitiesState => {
  return {
    ...state,
    responseConsegnaPacco,
  };
};

const handleSetPaccoSmarrito = (
  state: IClientActivitiesState,
  { responsePaccoSmarrito }: { responsePaccoSmarrito: IResponsePaccoSmarrito | null }
): IClientActivitiesState => {
  return {
    ...state,
    responsePaccoSmarrito,
  };
};

const handleSetVerifySale = (
  state: IClientActivitiesState,
  { responseVerifySale }: { responseVerifySale: ISaleData | null }
): IClientActivitiesState => {
  return {
    ...state,
    responseVerifySale,}};

const handleSetParcelSale = (
  state: IClientActivitiesState,
  { responseParcelSale }: { responseParcelSale: IParcelSale | null }
): IClientActivitiesState => {
  return {
    ...state,
    responseParcelSale,}};

const handleSetConfirmClientAcceptance = (
  state: IClientActivitiesState,
  { responseConfirmClientAcceptance }: { responseConfirmClientAcceptance: ResponseConfirmClientAcceptance | null }
): IClientActivitiesState => {
  return {
    ...state,
    responseConfirmClientAcceptance,
  };
};

const handleSetConfirmClientAcceptanceDatamatrix = (
  state: IClientActivitiesState,
  { responseConfirmClientAcceptanceDatamatrix }: { responseConfirmClientAcceptanceDatamatrix: ResponseAccettazioneDatamatrix | null }
): IClientActivitiesState => {
  return {
    ...state,
    responseConfirmClientAcceptanceDatamatrix,
  };
};

const handleSetEtichettaWebApp = (
  state: IClientActivitiesState,
  { responseEtichettaWebApp }: { responseEtichettaWebApp: ResponseEtichettaWebApp | null }
): IClientActivitiesState => {
  return {
    ...state,
    responseEtichettaWebApp,
  };
};

const handleSetEtichettaLottomatica = (
  state: IClientActivitiesState,
  { responseEtichettaLottomatica }: { responseEtichettaLottomatica: ResponseEtichettaLottomatica | null }
): IClientActivitiesState => {
  return {
    ...state,
    responseEtichettaLottomatica,
  };
};

const handleSetCodiceBustaBXL = (
  state: IClientActivitiesState,
  { responseConfirmCodiceBusta }: { responseConfirmCodiceBusta: ResponseConfirmCodiceBusta | null }
): IClientActivitiesState => {
  return {
    ...state,
    responseConfirmCodiceBusta,
  };
};

/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(RETRIEVE_VERIFY_DELIVERY_SUCCESS, handleSetVerifyDelivery),
  on(RETRIEVE_VERIFY_DELIVERY_NO_PIN_SUCCESS, handleSetVerifyDeliveryNoPin),
  on(RETRIEVE_RIFIUTA_PACCO_SUCCESS, handleSetRifiutaPacco),
  on(RETRIEVE_CONSEGNA_PACCO_SUCCESS, handleSetConsegnaPacco),
  on(RETRIEVE_PACCO_SMARRITO_SUCCESS, handleSetPaccoSmarrito),
  on(RETRIEVE_VERIFY_SALE_SUCCESS, handleSetVerifySale),
  on(RETRIEVE_PARCEL_SALE_SUCCESS, handleSetParcelSale),
  on(RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE_SUCCESS, handleSetConfirmClientAcceptance),
  on(RETRIEVE_CONFIRM_CLIENT_ACCEPTANCE_DATAMATRIX_SUCCESS, handleSetConfirmClientAcceptanceDatamatrix),
  on(RETRIEVE_ETICHETTE_LOTTOMATICA_SUCCESS, handleSetEtichettaLottomatica),
  on(RETRIEVE_ETICHETTE_WEBAPP_SUCCESS, handleSetEtichettaWebApp),
  on(RETRIEVE_CONFIRM_CODICE_BUSTA_SUCCESS, handleSetCodiceBustaBXL)
);

export const clientActivitiesReducer = (
  state: IClientActivitiesState | undefined,
  action: Action
): IClientActivitiesState => reducer(state, action);
